// Shared progress meter: labelled bar with optional caption.

export function ProgressMeter({
  value,
  label,
  caption,
  tone = "brand",
}: {
  /** 0-1 */
  value: number;
  label?: string;
  caption?: string;
  tone?: "brand" | "teal" | "amber" | "coral";
}) {
  const pct = Math.max(0, Math.min(100, Math.round(value * 100)));
  const toneVar =
    tone === "teal"
      ? "var(--signal-teal)"
      : tone === "amber"
        ? "var(--signal-amber)"
        : tone === "coral"
          ? "var(--signal-coral)"
          : null;

  return (
    <div>
      {(label || caption) && (
        <div className="flex items-baseline justify-between gap-3">
          {label && <span className="text-[13px] font-medium text-ink">{label}</span>}
          {caption && (
            <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
              {caption}
            </span>
          )}
        </div>
      )}
      <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-border">
        <div
          className={`h-full rounded-full transition-all ${toneVar ? "" : "brand-gradient"}`}
          style={{ width: `${pct}%`, ...(toneVar ? { background: toneVar } : {}) }}
        />
      </div>
    </div>
  );
}
